module.exports = __webpack_public_path__ + "static/home-banner-side-img1-1763b0a296c1f9aa3443e128798aa2be.png";